/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropterms1Inputs */

const en_dropterms1 = /** @type {(inputs: Dropterms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms (markdown)`)
};

const de_dropterms1 = /** @type {(inputs: Dropterms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen (Markdown)`)
};

/**
* | output |
* | --- |
* | "Terms (markdown)" |
*
* @param {Dropterms1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropterms1 = /** @type {((inputs?: Dropterms1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropterms1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropterms1(inputs)
	return de_dropterms1(inputs)
});
export { dropterms1 as "dropTerms" }